import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../library/assets/yt_icon.png'
import _imports_1 from '../library/assets/Facebook_Logo_Secondary.png'
import _imports_2 from '../library/assets/Instagram_Glyph.png'
import _imports_3 from '../library/assets/LI-In.png'


const _withScopeId = n => (_pushScopeId("data-v-57ff68cf"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "social-banner" }
const _hoisted_2 = { class: "asahi-social-banner-container" }
const _hoisted_3 = { class: "p-1" }
const _hoisted_4 = ["href"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "p-1" }
const _hoisted_8 = ["href"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "p-1" }
const _hoisted_12 = ["href"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = { class: "p-1" }
const _hoisted_16 = ["href"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_3 }, null, -1))
const _hoisted_18 = [
  _hoisted_17
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h3", null, _toDisplayString(_ctx.$t('Follow Us')), 1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("a", {
          href: _ctx.getLinkByName('youtube').url,
          target: "_blank",
          title: "YouTube",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.navigateToPath(_ctx.getLinkByName('youtube').url, 'YouTube')), ["prevent"]))
        }, _hoisted_6, 8, _hoisted_4)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("a", {
          href: _ctx.getLinkByName('fb').url,
          target: "_blank",
          title: "Facebook",
          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.navigateToPath(_ctx.getLinkByName('fb').url, 'Facebook')), ["prevent"]))
        }, _hoisted_10, 8, _hoisted_8)
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("a", {
          href: _ctx.getLinkByName('instagram').url,
          target: "_blank",
          title: "Instagram",
          onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.navigateToPath(_ctx.getLinkByName('instagram').url, 'Instagram')), ["prevent"]))
        }, _hoisted_14, 8, _hoisted_12)
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("a", {
          href: _ctx.getLinkByName('linkedin').url,
          target: "_blank",
          title: "LinkedIn",
          onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.navigateToPath(_ctx.getLinkByName('linkedin').url, 'LinkedIn')), ["prevent"]))
        }, _hoisted_18, 8, _hoisted_16)
      ])
    ])
  ]))
}